import { Place } from '../models';
export function getRoutePreview(wayPoints) {
  return {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: wayPoints.reduce((res, wayPoint) => {
        if (wayPoint) res.push(wayPoint.point.coordinates);
        return res;
      }, [])
    },
    properties: {
      index: -1,
      prevWayPointIndex: -1
    }
  };
}
export function getDraggedRoutePreview(currentWayPoints, draggedWayPointIndex, {
  lat,
  lng
}) {
  const newWayPoint = new Place(undefined, {
    type: 'Point',
    coordinates: [Math.round(lng * 1000000) / 1000000, Math.round(lat * 1000000) / 1000000]
  });
  const wayPoints = [...currentWayPoints];
  wayPoints[draggedWayPointIndex] = newWayPoint;
  const feature = {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: wayPoints.reduce((res, wayPoint) => {
        if (wayPoint) res.push(wayPoint.point.coordinates);
        return res;
      }, [])
    },
    properties: {
      index: -1,
      prevWayPointIndex: -1
    }
  };
  return {
    wayPoints,
    feature
  };
}